var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.7083 9.16675H3.29167C2.85444 9.16675 2.5 9.52119 2.5 9.95841V10.0417C2.5 10.479 2.85444 10.8334 3.29167 10.8334H16.7083C17.1456 10.8334 17.5 10.479 17.5 10.0417V9.95841C17.5 9.52119 17.1456 9.16675 16.7083 9.16675Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.7083 13.3333H3.29167C2.85444 13.3333 2.5 13.6877 2.5 14.1249V14.2083C2.5 14.6455 2.85444 14.9999 3.29167 14.9999H16.7083C17.1456 14.9999 17.5 14.6455 17.5 14.2083V14.1249C17.5 13.6877 17.1456 13.3333 16.7083 13.3333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.7083 5H3.29167C2.85444 5 2.5 5.35444 2.5 5.79167V5.875C2.5 6.31223 2.85444 6.66667 3.29167 6.66667H16.7083C17.1456 6.66667 17.5 6.31223 17.5 5.875V5.79167C17.5 5.35444 17.1456 5 16.7083 5Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuButton);
export default __webpack_public_path__ + "static/media/icon_menu_button.1efb5e09d32a7d31c0463a80802e2bd1.svg";
export { ForwardRef as ReactComponent };